// import ContactUsIcon from "components/Icons/ContactUsIcon"
// import FacebookIcon from "components/Icons/FacebookIcon"
// import InstagramIcon from "components/Icons/InstagramIcon"
// import LocationOutlineIcon from "components/Icons/LocationOutlineIcon"
// import MailIcon from "components/Icons/MailIcon"
// import PhoneIcon from "components/Icons/PhoneIcon"
// import WhatsappIcon from "components/Icons/WhatsappIcon"
// const EVENT_PLANNING_ID = process.env.EVENT_PLANNING_ID

import CalendarIcon from "reusable/icons/CalendarIcon"
import MailIcon from "reusable/icons/MailIcon"
import PhoneIcon from "reusable/icons/PhoneIcon"

export type LinksType = {
  title: string
  link: string
  blank?: boolean
  iconName?: string
  iconComp?: JSX.Element
  onlyShowLogin?: boolean
}

export type NavigationLinksType = {
  [key: string]: LinksType
}

export type NestedNavigationLinksType = {
  title: string
  links: LinksType[]
}
const Links: NavigationLinksType = {
  FaceBook: {
    title: "Facebook",
    link: "https://www.facebook.com/%D7%9E%D7%90%D7%A4%D7%99%D7%99%D7%AA-%D7%9C%D7%97%D7%9E%D7%99%D7%9D-100287132211720/?fbclid=IwAR10bYY4CIwaoYbNMzrtOZcKWY3h3LJ8degRauvdoQfsubLITDmm6VTPhEM",
    iconName: "facebook",
    // iconComp: <FacebookIcon />,
  },
  Instagram: {
    title: "Instagram",
    link: "https://www.instagram.com/lehamimbakery/",
    iconName: "instagram",
    // iconComp: <InstagramIcon />,
  },
  ContactUs: {
    title: "צרו קשר",
    link: "/contact-us",
    iconName: "ContactUsIcon",
    // iconComp: <ContactUsIcon />,
  },
  Chat: {
    title: "צ'אט",
    link: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
    iconName: "",
    blank: true,
  },
  Phone: {
    title: "03-7622035",
    link: "tel:03-7622035",
    iconName: "phone",
    // iconComp: <PhoneIcon />,
  },
  Whatsapp: {
    title: "ווטסאפ",
    link: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
    iconName: "whatsapp",
    // iconComp: <WhatsappIcon />,
  },
  Example: {
    title: "דוגמא",
    link: "/",
    iconName: "location",
    blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  FinancingCalculator: {
    title: "מחשבון מימון",
    link: "/models/finance",
    iconName: "location",
    blank: false,
    // iconComp: <LocationOutlineIcon />,
  },
  Showrooms: {
    title: "אולמות תצוגה",
    link: "/show-rooms",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  ServicesCenters: {
    title: "תיאום תור למרכזי השירות",
    link: "/services-centers",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  PriceList: {
    title: "מחירון רכבים",
    link: "/car-list",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  PriceListTransport: {
    title: "מחירון חלפים",
    link: "/spare-price-list",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  Insurance: {
    title: "ביטוח",
    link: "/insurance",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  Journalism: {
    title: "מהעיתונות",
    link: "/",
    iconName: "location",
    blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  CarFleet: {
    title: "מאזדה לעסקים",
    link: "/car-fleets",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  PrivacyPolicy: {
    title: "מדיניות הפרטיות",
    link: "/privacy-policy",
    iconName: "location",
    blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  TermsOfUse: {
    title: "תנאי השימוש",
    link: "/terms-of-use",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  MazdaElectricAppPolicy: {
    title: "מדיניות שימוש ופרטיות MAZDA ELECTRIC APP",
    link: "",
    iconName: "location",
    blank: true,
  },
  Accessibility: {
    title: "הצהרת נגישות",
    link: "/accessibility",
    iconName: "location",
    // blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  SiteMap: {
    title: "מפת האתר",
    link: "/sitemap",
    iconName: "location",
    blank: true,
    // iconComp: <LocationOutlineIcon />,
  },
  TestDrive: {
    title: "נסיעות מבחן",
    link: "/",
    iconName: "calendar",
    blank: true,
    iconComp: <CalendarIcon />,
  },
  TestDriveLink: {
    title: "הזמנת נסיעת הדגמה",
    link: "/test-drive",
    iconName: "",
  },
  Mail: {
    title: "מייל",
    link: "mailto:service1@delekmotors.co.il",
    iconName: "mail",
    iconComp: <MailIcon />,
    blank: true,
  },
  ShowRoomsPhone: {
    title: "אולמות תצוגה",
    link: "tel:*9888",
    iconName: "phone",
    iconComp: <PhoneIcon />,
    blank: true,
  },
  ShowRoomsDesktop: {
    title: "אולמות תצוגה",
    link: "show-rooms",
    iconName: "phone",
    iconComp: <PhoneIcon />,
    blank: true,
  },
  CustomerServicePhone: {
    title: "שירות לקוחות",
    link: "tel:089139995",
    iconName: "phone",
    iconComp: <PhoneIcon />,
    blank: true,
  },
  CustomerServiceDesktop: {
    title: "שירות לקוחות",
    link: "/contact-us",
    iconName: "phone",
    iconComp: <PhoneIcon />,
    blank: true,
  },
  Service: {
    title: "שירות",
    link: "/",
    iconName: "",
  },
  OnlinePurchase: {
    title: "רכישה",
    link: "/models/shop",
    iconName: "",
  },
  OnlinePurchaseSubmenu: {
    title: "בחירת דגם",
    link: "/models/shop",
    iconName: "",
  },
  DigitalContent: {
    title: "לבלוג שלנו",
    link: "https://blog.mazda.co.il",
    iconName: "",
    blank: true,
  },
  ContactUsNow: {
    title: "השארת פרטים",
    link: "/contact-us",
    iconName: "",
  },
  ForModels: {
    title: "לכל הדגמים",
    link: "/models",
    iconName: "",
  },
  VarietyOfModels: {
    title: "לכל הדגמים",
    link: "/models",
    iconName: "",
  },
  Recall: {
    title: "ריקול (קריאה חוזרת)",
    link: "/recall",
    iconName: "",
  },
  ServiceInstructions: {
    title: "הוראות שירות",
    link: "/service-instructions",
    iconName: "",
  },
  Warranty: {
    title: "כתב אחריות",
    link: "/warranty",
    iconName: "",
  },
  WarrantyExtensionCheck: {
    title: "הארכת אחריות",
    link: "/warranty-extension",
    iconName: "",
  },
  SpareParts: {
    title: "מחירון חלפים",
    link: "/",
    iconName: "",
  },
  CheckColorCode: {
    title: "בדיקת קוד צבע",
    link: "/color-code",
    iconName: "",
  },
  ServicePlans: {
    title: "תוכנית טיפול לרכב",
    link: "/service-plans",
    iconName: "",
  },
  Hamesayat: {
    title: "המסייעת",
    link: "/hamesayat",
    iconName: "",
  },
  VideoTutorials: {
    title: "סרטוני הדרכה לרכב",
    link: "/video-tutorials",
    iconName: "",
  },
  ShopLogin: {
    title: "התחברות",
    link: "/shop/login",
    iconName: "",
  },
  AboutUs: {
    title: "בואו להכיר את מאזדה",
    link: "/about-us",
    iconName: "",
  },
  Hesder: {
    title: "אחריות מוארכת לכריות אוויר",
    link: "/הודעה על אחריות מוארכת לכריות אוויר שבוצע בעניינן הליך.pdf",
    iconName: "",
    blank: true,
  },
  Meeting: {
    title: "תיאום פגישה",
    link: "/meeting",
    iconName: "",
  },
}

// example:
// const SocialLinks: NestedNavigationLinksType = {
//   title: 'עקבו אחרינו',
//   links: [Links['FaceBook'], Links['Instagram']],
// }

// //////////// mazda /////////////////////////////////////////////////////////

const HeaderLinkListMobile: NestedNavigationLinksType[] = [
  { title: "מגוון הדגמים", links: [Links.VarietyOfModels] },
  { title: "צ'אט", links: [Links.Chat] },
]

const SideDrawerMobile: NestedNavigationLinksType[] = [
  { title: "לכל הדגמים", links: [Links.VarietyOfModels] },
  {
    title: "מימון וביטוח",
    links: [Links.FinancingCalculator, Links.Insurance],
  },
  {
    title: "שירות ותמיכה לרכב",
    links: [
      Links.ServicesCenters,
      Links.VideoTutorials,
      Links.PriceList,
      Links.Recall,
      Links.PriceListTransport,
      Links.CheckColorCode,
      Links.Warranty,
      Links.WarrantyExtensionCheck,
      Links.ServiceInstructions,
      Links.ServicePlans,
      Links.Hesder,
      Links.Hamesayat,
    ],
  },
  { title: "אולמות תצוגה", links: [Links.Showrooms] },

  {
    title: "יצירת קשר",
    links: [Links.Meeting, Links.ContactUsNow, Links.CarFleet],
  },
  {
    title: "אודות מאזדה",
    links: [Links.AboutUs, Links.DigitalContent],
  },
]
const HeaderTopButtonsLinks: LinksType[] = [
  Links.TestDriveLink,
  { ...Links.OnlinePurchaseSubmenu, title: "רכישה Online" },
]

const HeaderLinkListDesktop: NestedNavigationLinksType[] = [
  { title: "מגוון הדגמים", links: [Links.VarietyOfModels] },
  ...SideDrawerMobile.filter(
    (item) =>
      !(item.links.length === 1 && item.links[0] === Links.VarietyOfModels)
  ),
]

const FooterTalkToUsDesktop: LinksType[] = [
  Links.ShowRoomsDesktop,
  Links.CustomerServiceDesktop,
  Links.Mail,
]

const FooterTalkToUsMobile: LinksType[] = [
  Links.ShowRoomsPhone,
  Links.CustomerServicePhone,
  Links.Mail,
]

const FooterPersonalEra: LinksType[] = [Links.TestDrive]

const FooterToolBox: LinksType[] = [
  Links.FinancingCalculator,
  Links.Showrooms,
  Links.PriceList,
  Links.Insurance,
]

const FooterAbout: LinksType[] = [
  Links.AboutUs,
  Links.PrivacyPolicy,
  Links.TermsOfUse,
  Links.Accessibility,
  Links.SiteMap,
]

const ShopLinks: NestedNavigationLinksType[] = [
  { title: "לדגמים", links: [Links.OnlinePurchase] },
  { title: "התחברות", links: [] },
  { title: "צ'אט", links: [Links.Chat] },
]

export {
  FooterAbout,
  FooterPersonalEra,
  FooterTalkToUsDesktop,
  FooterTalkToUsMobile,
  FooterToolBox,
  HeaderLinkListDesktop,
  HeaderLinkListMobile,
  HeaderTopButtonsLinks,
  Links,
  ShopLinks,
  SideDrawerMobile,
}
